// ⚠️ AUTO-GENERATED FROM CORE REPO
// DO NOT EDIT — changes will be overwritten

if (!customElements.get('core-product-includes')) {
  customElements.define('core-product-includes', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.initialized) {
        this.initialized = true;
        this.grid = this.querySelector('ul');
        this.titles = [...this.querySelectorAll('h3')];
        this.titles.forEach(title => {
          const words = title.textContent.trim().split(/\s+/);
          title.replaceChildren();
          words.forEach((word, index) => {
            if (index) title.append(document.createTextNode(' '));
            const span = document.createElement('span');
            span.className = 'multiple-product-form__includes-word';
            span.textContent = word;
            title.append(span);
          });
        });
        this.controls = this.querySelector('.multiple-product-form__includes-controls');
        this.toggle = this.querySelector('.multiple-product-form__includes-toggle');
        if (this.toggle) {
          this.toggle.hidden = false;
          this.setExpanded(false);
          this.toggle.addEventListener('click', () => this.setExpanded(this.dataset.collapsed === 'true'));
        }
        const controls = this.controls;
        if (controls) {
          controls.hidden = false;
          controls.addEventListener('click', event => {
            const button = event.target.closest('[data-carousel-direction]');
            if (!button) return;
            this.grid.scrollBy({
              left: this.grid.clientWidth * Number(button.dataset.carouselDirection),
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            });
          });
        }
      }
      this.observer ||= new ResizeObserver(() => this.scheduleFit());
      this.observer.observe(this);
      this.onFontsLoaded ||= () => this.scheduleFit();
      document.fonts?.addEventListener('loadingdone', this.onFontsLoaded);
      document.fonts?.ready.then(() => this.scheduleFit());
      this.scheduleFit();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      document.fonts?.removeEventListener('loadingdone', this.onFontsLoaded);
    }

    setExpanded(expanded) {
      this.grid.hidden = !expanded;
      this.dataset.collapsed = String(!expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.setAttribute('aria-label', expanded ? this.toggle.dataset.collapseAriaLabel : this.toggle.dataset.expandAriaLabel);
      this.scheduleFit();
    }

    scheduleFit() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.fitTitles());
    }

    fitTitles() {
      if (!this.clientWidth || !this.titles?.length) return;
      this.style.removeProperty('--includes-fitted-title-size');
      const maximum = parseFloat(getComputedStyle(this.titles[0]).fontSize);
      // Measure every flavor, including collapsed ones, so expanding never
      // changes the shared font size. Hidden cards inherit the visible width.
      const visible = this.titles.find(title => title.clientWidth);
      if (!visible) return;
      let size = maximum;
      this.titles.forEach(title => {
        const width = title.clientWidth || visible.clientWidth;
        title.querySelectorAll('span').forEach(word => {
          let wordWidth = word.getBoundingClientRect().width;
          if (!wordWidth) {
            const probe = word.cloneNode(true);
            visible.append(probe);
            wordWidth = probe.getBoundingClientRect().width;
            probe.remove();
          }
          if (wordWidth > width) size = Math.min(size, maximum * width / wordWidth);
        });
      });
      const fitted = `${Math.floor(size * 100) / 100}px`;
      this.style.setProperty('--includes-fitted-title-size', fitted);
    }
  });
}
